// extracted by mini-css-extract-plugin
export var textInput = "_et-0";